import React, { useContext } from 'react'
import { QuizQuestionContext, SCREEN_QUIZ_QUESTION } from '../contextAPI'
import { QuizQuestionBase } from '../QuizQuestion'

export const PinterestLinkYourBoardPage: React.FC = () => {
  const { setQuizScreen } = useContext(QuizQuestionContext)
  setQuizScreen(SCREEN_QUIZ_QUESTION.PINTEREST_LINK_YOUR_BOARD)
  return <QuizQuestionBase hardScreen={SCREEN_QUIZ_QUESTION.PINTEREST_LINK_YOUR_BOARD} />
}
